(async () => {
  const {
    updateURLParams,
    historyPush,
    parseHTML,
    loadScript,
    loadStyle
  } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('product-bundle-form', class extends baseComponent.default {
    elements = {
      form: 'form',
      addButton: '[data-add-button]',
      buyButton: '[data-buy-button]',
      content: '[data-content]',
      price: '[data-bundle-price]',
      originalPrice: '[data-bundle-original-price]',
      productSelection: '.bundle-selection__line [data-bundle-select]',
      bundleAccsSelection: '.bundle-selection__line_free [data-bundle-select]',
      sezzlePrice: '.sezzle_price',
      bundleSwiperContainer: '[data-bundle-swiper]',
      swatchContainer: '.bundle-product-swatch-wrapper',
      colorTitle: '[data-color-title]',
      qty: '[name="quantity"]'
    };
    async render() {
      await this._initSwiper();
      
      this.swiper = [];
      const allSwipers = document.querySelectorAll(this.elements.bundleSwiperContainer);
      allSwipers.forEach((slider, index) => {
        this.swiper[index] = new window.Swiper(slider, {
          slidesPerView: 3.1,
          simulateTouch: true,
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            640: {
              slidesPerView: 5
            }
          }
        });
      });
      
      this._updateSelectionPrices();
      
      this.sectionID = this.getAttribute('section-id');
      
      if (this.dataset.bundleDiscount != null) {
        this.discount = parseInt(this.dataset.bundleDiscount);
      }
      
      // this.galleryWrapper = document.querySelector(`#shopify-section-${this.sectionID} .product-bundle__gallery`);
      this.swatchContainer = this.querySelector(this.elements.swatchContainer);
      this.selections = this.querySelectorAll(this.elements.productSelection);

      this.accsSelections = this.querySelectorAll(this.elements.bundleAccsSelection);
      
      this.selections.forEach(($selection) => {
        $selection.addEventListener('click', this._onSelection.bind(this, $selection));
      });
      
      
      this.$qty.addEventListener('change', () => {
        this._updatePrice();
      });
      
      this.variant = {};
      
      this.addEventListener('variantChange', (e) => {
        var data = e.detail;
        
        if (data.variant) {
          var variant = data.variant;

          if (variant.available) {
            this.querySelector('.color-value').textContent = variant.option1;
            
            var targetImageDOM = document.querySelector(`.image-item[data-variant="${variant.id}"]`)
            document.querySelector('.image-item.actived').classList.remove('actived');
            
            if (targetImageDOM !== null) {
              targetImageDOM.classList.add('actived');
              this.dataset.productImage = targetImageDOM.dataset.imageUrl;
            }
            
            var activedPipe = this.querySelector('.bundle-selection__item.actived');
            if (activedPipe) {
              activedPipe.dataset.variantId = variant.id;
              if (variant.featured_image)
                activedPipe.dataset.imageUrl = variant.featured_image.src;
              else
                activedPipe.dataset.imageUrl = activedPipe.dataset.imageUrlDefault;
              
              activedPipe.dataset.productTitle = variant.name;
            }
          }
        }
      });
      
      this._updatePrice();
      
      if (this.hasAttribute('cart-popup'))
        this.$addButton.addEventListener('click', this._handleSubmit.bind(this));
    };
    
    async _initSwiper() {
      await loadStyle(window.theme.styles.Swiper);
      await loadScript(window.theme.scripts.Swiper, 'swiper');
    };
    
    _onSelection(selection) {
      if (selection.classList.contains('actived')) {
        return;
      } else {
        let $selectionLine = selection.closest('.bundle-selection__line');
        let $activedSelection = $selectionLine.querySelector('.bundle-selection__item.actived');
        let handle = selection.dataset.productHandle;
        $activedSelection.classList.remove('actived');
        
        let imgUrl = selection.dataset.imageUrl;
        selection.classList.add('actived');
        
        this._updateSelectionPrices();
        // this._updateImage(lineID, imgUrl);
        this._updatePrice();
        
        this._updateSwatch(handle);
        
        // if (window.innerWidth < 992)
        //   document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    }
    
    _updateSelectionPrices() {
      let bundleLine = this.querySelector('.bundle-selection__line');
      
      const allItems = bundleLine.querySelectorAll('.bundle-selection__item:not(.actived)');
      let selectedProduct = bundleLine.querySelector('.bundle-selection__item.actived');
      const price = parseInt(selectedProduct.dataset.price);
      selectedProduct.querySelector('.bundle-selection__product-price').innerHTML = formatMoney(price);
      
      allItems.forEach((item) => {
        let itemPrice = parseInt(item.dataset.price);
        let priceDiff = itemPrice - price;
        
        if (priceDiff > 0) {
          item.querySelector('.bundle-selection__product-price').innerHTML = '+' + formatMoney(priceDiff); 
        } else if (priceDiff == 0) {
          item.querySelector('.bundle-selection__product-price').innerHTML = '';
        } else {
          item.querySelector('.bundle-selection__product-price').innerHTML = '-' + formatMoney(-priceDiff);
        }
      });
    }
    
    _updateSwatch(handle) {
      fetch('/products/' + handle + '?view=new-bundle-ajax', {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.text())
      .then(responseText => {
        const html = responseText;
        const newDom = new DOMParser().parseFromString(html, 'text/html');
        
        let newSwatch = newDom.querySelector('.product-swatch-wrapper').innerHTML;
        if (this.swatchContainer !== null) {
          this.swatchContainer.innerHTML = newSwatch;
          var swatches = this.swatchContainer.querySelectorAll('product-variant-selector');
          swatches.forEach(swatch => {
            swatch.render();
          });
          
        } else {
          console.log('Swatch not available on this product!');
        }
      });
    }
    
    _getSelectedPrice() {
      let $selections = Array.from(this.selections);
      $selections = $selections.filter((selection) => {
        return selection.classList.contains('actived');
      });
      
      let $accsSelections = Array.from(this.accsSelections);
      $accsSelections = $accsSelections.filter((selection) => {
        return selection.classList.contains('actived');
      });
      
      let price = $selections
        .map((selection) => {
          return parseFloat(selection.dataset.price);
        }).reduce((a, b) => {
          return a+b;
        });
        
      let accsPrice = $accsSelections
      .map((selection) => {
        return parseFloat(selection.dataset.price);
      }).reduce((a, b) => {
        return a+b;
      });
        
      return price + accsPrice;
    }
    
    _updatePrice() {
      
      let price = this._getSelectedPrice();
      let times = 100 - this.discount;
      times = times / 100;
      
      let discountedPrice = price * times;
      
      this.$price.innerHTML = formatMoney(discountedPrice);
      this.$originalPrice.innerHTML = formatMoney(price);
      
      this.$sezzlePrice.innerHTML = formatMoney(discountedPrice / 4);
      
      
      this._updateButtonPrice(discountedPrice * this.$qty.value);
    }
    
    _updateButtonPrice(price) {
      this.$addButton.querySelector('.\\#button-text').innerHTML = window.theme.i18n.addToCart + ' - ' + formatMoney(price);
    }
    
    _updateImage(id, imgUrl) {
      if (this.galleryWrapper !== null) {
        let image = this.galleryWrapper.querySelector(`.bundle_img_wrapper[data-bundle-id="${id}"] img`);
        image.dataset.src = imgUrl;
        image.src = imgUrl;
      }
    }

    _handleSubmit(e) {
      e.preventDefault();
      const _this = this;
      const productUrl = this.getAttribute('product-url');
      const productImage = this.dataset.productImage;
      const productTitle = this.dataset.productTitle;
      
      this.formData = new FormData();
      
      let $selections = Array.from(this.selections);
      
      $selections = $selections.filter((selection) => {
        return selection.classList.contains('actived');
      });
      
      let $accsSelections = Array.from(this.accsSelections);
      
      $accsSelections = $accsSelections.filter((selection) => {
        return selection.classList.contains('actived');
      });
      
      let items = [];
      let qty = this.$qty.value;
      let properties = [];
      let uniqueBundleId = productUrl;
      let bundleParentId = 0;
      
      $selections.forEach((selection, index) => {
        if (index == 0) {
          bundleParentId = selection.dataset.variantId * 1;
        }
        uniqueBundleId += '---' + selection.dataset.variantId;
        properties.push({
          title: selection.dataset.productTitle,
          image: selection.dataset.imageUrl,
          id: selection.dataset.variantId * 1
        });
      });
      
      $accsSelections.forEach((selection, index) => {
        uniqueBundleId += '---' + selection.dataset.variantId;
        properties.push({
          title: selection.dataset.productTitle,
          image: selection.dataset.imageUrl,
          id: selection.dataset.variantId * 1
        });
      });
      
      $selections.forEach((selection) => {
        let data = {
          quantity: qty,
          id: selection.dataset.variantId * 1,
          properties: {
            _bundle_id: uniqueBundleId,
            _bundle_recog: 'new',
            _bundle_parentId: bundleParentId,
            _bundle_url: productUrl,
            _bundle_title: productTitle,
            _bundle_image: productImage,
            _bundle_items: properties
          }
        };
        
        // if (parseInt(selection.dataset.variantId) == parseInt(freeProductId)) {
        //   data = {
        //     quantity: qty,
        //     id: selection.dataset.variantId * 1,
        //     properties: {
        //       _bundle_id: uniqueBundleId,
        //       _bundle_parentId: bundleParentId,
        //       _bundle_url: productUrl,
        //       _bundle_title: productTitle,
        //       _bundle_image: productImage,
        //       _bundle_items: properties,
        //       _bundle_free: 'free'
        //     }
        //   };
        // }
        items.push(data);
      });
      
      $accsSelections.forEach((selection) => {
        let data = {
          quantity: qty,
          id: selection.dataset.variantId * 1,
          properties: {
            _bundle_id: uniqueBundleId,
            _bundle_recog: 'new',
            _bundle_parentId: bundleParentId,
            _bundle_url: productUrl,
            _bundle_title: productTitle,
            _bundle_image: productImage,
            _bundle_items: properties
          }
        };
        
        items.push(data);
      });
      
      this.formData = JSON.stringify({items: items});
      this._addToCartRequest();
    }

    async _addToCartRequest() {
      this._setLoading(true);
      
      try {
        const response = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: this.formData
        });
        
        if (!response.ok) {
          console.log('Failed to add items to cart');
          throw new Error('Failed to add items to cart');
        }
        
        const data = await response.json();
        console.log('Items successfully added:', data);
        if (data.status === 422) {
          if (!data.description) {
            console.warn(data);
            return;
          }
          this.append(error); 
          this._setLoading(false);
        } else {
          this.trigger('updateCart', {
            callback: () => {
              this._setLoading(false);
  
              if(this.cartSection) {
                this.cartSection.update();
              } else {
                this.trigger('openPopup', { target: 'CART' });
              }
            }
          }) 
        }
        
      } catch (error) {
        console.error('Error adding items:', error);
        this._setLoading(false);
      }

      // let headerConfig = {
      //     "Accept": "application/javascript"
      // }
      // if(typeof(this.formData) == 'string' ) {
      //   headerConfig = {
      //            'Content-Type': 'application/json'
      //         }
      // }
        
      // fetch(`${window.routes.cart_add_url}.js`, {
      //   method: 'POST',
      //   headers: headerConfig,
      //   body: this.formData
      // })
      // .then(res => {
      //   return res.json();
      // })
      // .then((data) => {
      //   if (data.status === 422) {
      //     if (!data.description) {
      //       console.warn(data);
      //       return;
      //     }
      //     this.append(error); 
      //     this._setLoading(false);
      //   } else {
      //     this.trigger('updateCart', {
      //       callback: () => {
      //         this._setLoading(false);
  
      //         if(this.cartSection) {
      //           this.cartSection.update();
      //         } else {
      //           this.trigger('openPopup', { target: 'CART' });
      //         }
      //       }
      //     }) 
      //   }
      // })
      // .catch(error => {
      //   this._setLoading(false);
      //   console.log(error);
      // });
    }
    
    _setLoading(status) {
      status 
        ? this.$addButton.setAttribute('loading', '')
        : this.$addButton.removeAttribute('loading');
    }
  });
})();

